





import { Vue, Component, Mixins } from "vue-property-decorator";
import _ from "lodash";

const geoJson = require("../../../../public/data-1519188124693-rkro_O5vz.json");

import * as echarts from "echarts";

import VChart, { THEME_KEY } from "vue-echarts";

@Component({
  components: {
    VChart
  },
  provide: {
    [THEME_KEY]: "light"
  }
})
export default class extends Mixins() {
  option: any = {
    visualMap: {
      left: "right",
      top: "bottom",
      text: ["多    (家)", "少    (家)"], // 文本，默认为数值文本
      min: 0,
      max: 500
    },
    tooltip: {
      trigger: "item"
    },
    toolbox: {
      show: true,
      feature: {
        dataView: {
          readOnly: false
        },
        restore: {},
        saveAsImage: {
          pixelRatio: 4
        }
      }
    },
    grid: {
      right: 40,
      top: 100,
      bottom: 40,

      width: "20%"
    },
    xAxis: {
      name: "数量",
      type: "value",
      scale: true,
      position: "top",
      boundaryGap: false,
      splitLine: { show: false },
      axisLine: { show: false },
      axisTick: { show: false }
    },
    yAxis: {
      type: "category",
      name: "TOP 20",
      nameGap: 16,
      data: []
    },
    series: [
      {
        name: "场馆数",
        left: 10,
        type: "map",
        zoom: 0.7,
        map: "chinacity",
        label: {
          // normal: {
            show: false
          // }
        },
        roam: true,
        data: [],
        tooltip: {
          formatter: (params: any, ticket: string, callback: any) =>
            `${params.name}: ${params.value || 0}家场馆`
        }
      },
      {
        name: "场馆数排行",
        id: "bar",
        zlevel: 2,
        type: "bar",
        symbol: "none",
        label: {
          // normal: {
            show: true
          // }
        },
        tooltip: {
          formatter: (params: any, ticket: string, callback: any) =>
            `${params.name}: ${params.value || 0}家场馆`
        },
        data: []
      }
    ]
  };

  ei: any = {};

  beforeCreate() {
    // console.log(geoJson)
    echarts.registerMap("chinacity", geoJson);
  }

  async mounted() {
    const res = await this.$store.dispatch("statistics/getStadiumMap", {
      iscity: 1
    });
    if (res && res.Data && res.Data.map && res.Data.top20) {
      this.option.series[0].data = [];
      for (const obj of res.Data.map) {
        this.option.series[0].data.push({
          name: obj.city_name,
          value: parseInt(obj.value, 10)
        });
      }

      res.Data.top20.sort((a: any, b: any) => parseInt(a.value, 10) - parseInt(b.value, 10));

      for (const obj of res.Data.top20) {
        this.option.yAxis.data.push(obj.city_name);
        this.option.series[1].data.push(parseInt(obj.value, 10));
      }
    }
  }
}
